module.exports = "/wwwroot/img/waste_search_page.png?ver=3ad916cf";